<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14Xnn6m/media/FC-9781398416611.jpg?1685790893464" alt="This image is the cover for the book Against the Rising Sun"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Against the Rising Sun
      </h1>
      <p class="bookDescription body article font2">
        <p>In the 1962 edition of Australia in the War of 1939-45, Dudley McCarthy describes his account as “the story of small groups of men, infinitesimally small against the mountains in which they fought, who killed one another in stealthy and isolated encounters beside the tracks which were life to all of them; of warfare in which men first conquered the country and then allied themselves with it and then killed or died in the midst of a great loneliness.” The jungle warfare in New Guinea and throughout the Pacific tested troops and their support apparatus to the very limits of endurance. Often the test proved too difficult. Once hardened by experience, those fighting men who lived and died in the jungle, eventually became masters of their surroundings, with the strength and skill required to dominate and defeat their opponents. The jungle changed those who fought within its depths fundamentally. Survival in the jungle requires stamina, prudence, and imagination to compensate for the discomfort, disorientation, and isolation the jungle imposes on all who venture within. The jungle is a primaeval world in which sound and light, heat and damp collide, corrode and corrupt, until all that is left is sensation, fear, uncertainty, and McCarthy’s ‘great loneliness’. Against the Rising Sun is the first novel by Steven Sharman, born of a twin passion for history and fiction, dedicated to courage under fire.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steven Sharman
      </h2>
      
      <p class="authorDescription body article">Steven Sharman holds Honours in Modern History and hails from the Central Coast of New South Wales. A published author of short fiction since 2014, Steven currently lives in Sydney’s Inner West, where he operates an English language coaching business. Trained as a historian, Steven writes non-fiction with a focus on Australia’s relations with Asia; his particular expertise relates to the Indonesian annexation of East Timor in 1975. Discover samples of Steve Sharman’s short works, including short stories, essays and poems at URL: novelt.info and stevesharm.substack.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?64f74466